import React, { useState } from 'react';
import { Tabs, type TabsProps } from 'antd';
import { theme } from '../theme';
import { PageTitle } from './common';

interface ConfiguracionProduccionTabsProps {
  presentacionesComponent: React.ReactNode;
  fardosComponent: React.ReactNode;
  playaComponent: React.ReactNode;
  semillasComponent: React.ReactNode;
  silobolsaComponent: React.ReactNode;
}

const ConfiguracionProduccionTabs: React.FC<ConfiguracionProduccionTabsProps> = ({
  presentacionesComponent,
  fardosComponent,
  playaComponent,
  semillasComponent,
  silobolsaComponent,
}) => {
  const [activeKey, setActiveKey] = useState('1');

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Presentaciones',
      children: presentacionesComponent,
    },
    {
      key: '2',
      label: 'Fardos',
      children: fardosComponent,
    },
    {
      key: '3',
      label: 'Playa',
      children: playaComponent,
    },
    {
      key: '4',
      label: 'Semillas',
      children: semillasComponent,
    },
    {
      key: '5',
      label: 'Silobolsa',
      children: silobolsaComponent,
    },
  ];

  return (
    <div>
      <PageTitle>Configuración de Producción</PageTitle>

      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        size="large"
        items={items}
        style={{
          backgroundColor: 'white',
          padding: '0 24px',
          borderRadius: theme.styles.borderRadius,
          boxShadow: theme.styles.boxShadow,
        }}
        tabBarStyle={{
          marginBottom: '24px',
          borderBottom: `2px solid ${theme.colors.borderLight}`,
        }}
      />
    </div>
  );
};

export default ConfiguracionProduccionTabs;
